import { FilePdfOutlined } from '@ant-design/icons';
import { Alert, Button, Checkbox, Modal, Popconfirm } from 'antd';
import { FC, useState, useEffect } from 'react';
import { ReactNode } from 'react';

interface RequestFeedbackButtonProps {
  updateEmbedding: (requests: any) => void;
  requestChangesField: { [key: string]: boolean };
  disabled: boolean;
}

export const RequestFeedbackButton: FC<RequestFeedbackButtonProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  interface Request {
    [key: string]: boolean | string | ReactNode;
  }

  const [request, setRequest] = useState<Request>({
    value: 'documentRequestType',
    message: false,
    icon: <FilePdfOutlined />
  });

  const initializeRequestState = () => {
    const initialRequest: any = {
      value: 'documentRequestType',
      message: 'Request Document Update',
      icon: <FilePdfOutlined />
    };

    Object.keys(props.requestChangesField).forEach((field) => {
      initialRequest[field] = false;
    });

    return initialRequest;
  };

  useEffect(() => {
    setRequest(initializeRequestState());
  }, [props.requestChangesField]);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    if (!Object.keys(props.requestChangesField).some((field) => request[field])) {
      setShowAlert(true);
      return;
    }

    setIsOpen(false);
    setShowAlert(false);
    props.updateEmbedding(request);
  };

  const onCancel = () => {
    setIsOpen(false);
  };

  const onCheck = (e: any) => {
    setShowAlert(false);
    const { value, checked } = e.target;
    setRequest((prevRequest) => ({
      ...prevRequest,
      [value]: checked
    }));
  };

  const footerButton = (
    <Popconfirm title="Are you sure?" description="Are you sure you want to request a document update for these changes?" onConfirm={closeModal}>
      <Button type="primary">Add Request</Button>
    </Popconfirm>
  );

  return (
    <>
      <Modal title="Request Update" open={isOpen} onCancel={onCancel} footer={footerButton}>
        {showAlert && <Alert message="Please select at least one option" type="error" />}
        <div className="m-5">
          <h3>Request Applicant to:</h3>
          {Object.keys(props.requestChangesField).map((field) => (
            <div key={field} className="mb-1">
              <Checkbox value={field} onChange={onCheck} checked={!!request[field] || false}>
                {field.replace(/([A-Z])/g, ' $1').toLowerCase()}
              </Checkbox>
              <br />
            </div>
          ))}
        </div>
      </Modal>
      <Button className="w-full rounded-lg mr-2 mb-2 mt-2" onClick={openModal} disabled={props.disabled}>
        <FilePdfOutlined /> Request Update
      </Button>
    </>
  );
};
